import { render, staticRenderFns } from "./Registro.vue?vue&type=template&id=085c55c2"
import script from "./Registro.vue?vue&type=script&lang=js"
export * from "./Registro.vue?vue&type=script&lang=js"
import style0 from "./Registro.vue?vue&type=style&index=0&id=085c55c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports